import { Component, OnInit } from "@angular/core";
import { RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { PrimeNGSharedModule } from "./shared/prime/prime-ng.module";
import { FooterComponent } from "./shared/footer/footer.component";
import { SessionService } from "@core/services/session/session.service";
import { filter } from "rxjs/operators";
import { LoaderComponent } from "@shared/components/loader/loader.component";
import { ToastMessageComponent } from "@shared/components/toast-message/toast-message.component";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, FooterComponent, LoaderComponent, ToastMessageComponent],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  showHeader: boolean = true;

  constructor(private readonly session: SessionService, private router: Router) {
    // Hide header on login and signup routes
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        const url = e.urlAfterRedirects || e.url;
        this.showHeader = !(url.startsWith("/login") || url.startsWith("/signup"));

        // Add a class to body for home/dashboard routes to give extra bottom padding
        const isHome = url === "/" || url.startsWith("/home") || url.startsWith("/dashboard");
        if (isHome) {
          document.body.classList.add("home-padding");
        } else {
          document.body.classList.remove("home-padding");
        }
      });
  }

  ngOnInit(): void {
    this.session.initSessionWatcher();
  }

  // Accept number or Event payload from footer; extract numeric height and apply it
  onFooterHeightChange(heightOrEvent: any): void {
    let height: number | null = null;

    if (typeof heightOrEvent === "number") {
      height = heightOrEvent;
    } else if (heightOrEvent && typeof heightOrEvent === "object") {
      // handle CustomEvent.detail or Event-like payloads
      if (typeof heightOrEvent.detail === "number") {
        height = heightOrEvent.detail;
      } else if (heightOrEvent.target && heightOrEvent.target.offsetHeight) {
        height = Number(heightOrEvent.target.offsetHeight) || null;
      }
    }

    // Fallback: try to coerce to number
    if (height === null) {
      const coerced = Number(heightOrEvent);
      height = Number.isFinite(coerced) ? coerced : null;
    }

    if (height && Number.isFinite(height)) {
      document.documentElement.style.setProperty("--footer-height", `${height}px`);
      // ensure the page content is pushed above the fixed footer
      document.body.style.paddingBottom = `${height}px`;
    } else {
      // use default
      document.documentElement.style.setProperty("--footer-height", `56px`);
      document.body.style.paddingBottom = `56px`;
    }
  }
}
